export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  } as React.CSSProperties,

  sectionTitle: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#374151',
    marginBottom: '4px',
  } as React.CSSProperties,

  sectionSubtitle: {
    fontSize: '13px',
    color: '#6b7280',
    marginBottom: '12px',
  } as React.CSSProperties,

  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '10px',
  } as React.CSSProperties,

  card: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    height: '120px',
    padding: '12px 10px',
    borderWidth: '1.5px',
    borderStyle: 'solid',
    borderColor: '#d1d5db',
    borderRadius: '10px',
    backgroundColor: '#ffffff',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    userSelect: 'none',
    textAlign: 'center',
    boxSizing: 'border-box',
  } as React.CSSProperties,

  cardSelected: {
    borderColor: '#00758d',
    backgroundColor: 'rgba(0,117,141,0.05)',
    boxShadow: '0 0 0 1px #00758d',
  } as React.CSSProperties,

  cardIcon: {
    color: '#00758d',
  } as React.CSSProperties,

  cardTitle: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#111827',
    lineHeight: '16px',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
  } as React.CSSProperties,

  cardFormats: {
    fontSize: '11px',
    color: '#9ca3af',
    lineHeight: '14px',
  } as React.CSSProperties,

  checkmark: {
    position: 'absolute',
    top: '6px',
    right: '6px',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: '#00758d',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    fontWeight: 700,
    lineHeight: 1,
  } as React.CSSProperties,

  addBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '10px 16px',
    fontSize: '14px',
    fontWeight: 500,
    color: '#00758d',
    backgroundColor: 'transparent',
    border: '2px dashed #00758d',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background-color 0.15s ease',
  } as React.CSSProperties,

  customForm: {
    backgroundColor: '#f9fafb',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    padding: '16px',
  } as React.CSSProperties,

  formRow: {
    marginBottom: '12px',
  } as React.CSSProperties,

  formGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px',
    marginBottom: '12px',
  } as React.CSSProperties,

  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: 500,
    color: '#374151',
    marginBottom: '4px',
  } as React.CSSProperties,

  input: {
    width: '100%',
    padding: '8px 12px',
    fontSize: '14px',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    outline: 'none',
    backgroundColor: '#ffffff',
    color: '#111827',
    boxSizing: 'border-box',
  } as React.CSSProperties,

  checkboxRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    color: '#374151',
    marginBottom: '12px',
  } as React.CSSProperties,

  formActions: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
  } as React.CSSProperties,

  btnPrimary: {
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: 500,
    color: '#ffffff',
    backgroundColor: '#00758d',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
  } as React.CSSProperties,

  btnCancel: {
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: 500,
    color: '#374151',
    backgroundColor: '#ffffff',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    cursor: 'pointer',
  } as React.CSSProperties,

  summaryList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  } as React.CSSProperties,

  summaryRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 14px',
    backgroundColor: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
  } as React.CSSProperties,

  summaryLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flex: 1,
    minWidth: 0,
  } as React.CSSProperties,

  summaryLabel: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#111827',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  } as React.CSSProperties,

  summaryRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexShrink: 0,
  } as React.CSSProperties,

  pillRequired: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 12px',
    fontSize: '12px',
    fontWeight: 600,
    borderRadius: '9999px',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    border: 'none',
    userSelect: 'none',
    backgroundColor: '#00758d',
    color: '#ffffff',
  } as React.CSSProperties,

  pillOptional: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 12px',
    fontSize: '12px',
    fontWeight: 600,
    borderRadius: '9999px',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    border: 'none',
    userSelect: 'none',
    backgroundColor: '#e5e7eb',
    color: '#374151',
  } as React.CSSProperties,

  deleteBtn: {
    padding: '4px 8px',
    fontSize: '13px',
    fontWeight: 500,
    border: '1px solid transparent',
    borderRadius: '4px',
    backgroundColor: 'transparent',
    color: '#6b7280',
    cursor: 'pointer',
    transition: 'color 0.15s ease',
  } as React.CSSProperties,

  emptyState: {
    color: '#9ca3af',
    fontStyle: 'italic',
    fontSize: '14px',
    textAlign: 'center',
    padding: '16px',
  } as React.CSSProperties,

  separator: {
    borderTop: '1px solid #e5e7eb',
    marginTop: '4px',
    marginBottom: '4px',
  } as React.CSSProperties,
};
